import actions from './actions'

export default function IntervalsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INTERVAL:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INTERVAL:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
        openModal: action.openModal
      }
    case actions.RESET_INTERVAL:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
        openModal: null
      }
    case actions.NEW_INTERVAL:
      return {
        ...state,
        editing: { intervalID: 0 },
        loading: false,
        saveSuccess: false,
        openModal: true

      }
    case actions.CREATE_INTERVAL_RECIEVED ||
      actions.UPDATE_INTERVAL_RECIEVED ||
      actions.DELETE_INTERVAL_RECIEVED:
      return {
        ...state,
        editing: { intervalID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
